import modelExtend from 'dva-model-extend';

const notHiddenChildrenModel = modelExtend({
  namespace: 'notHiddenChildren',
  state: [],
  reducers: {
    add(state, { payload }) {
      return state.includes(payload) ? state : state.concat(payload);
    },
    delete(state, { payload }) {
      return state.filter((id) => id !== payload);
    },
    reset() {
      return [];
    },
  },
  effects: {
    *delete(_, { put }) {
      yield put({ type: 'form/saveDraft' });
    },
  },
});

export default notHiddenChildrenModel;
